import React from "react";
import { useState, useEffect } from "react";
import styles from "../../assets/css/building-user.module.css";
import { appVariables } from "../../constants/appVariables";
import {
  HistoryOutlined,
  SearchOutlined,
  FilterOutlined,
  CalendarOutlined,
  DollarOutlined,
  HomeOutlined,
  TagOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { TbHomeHand } from "react-icons/tb";
import { FaRegCreditCard } from "react-icons/fa";

const mockData = [];

const Payment = () => {
  return <div>Thanh toán</div>;
};

export default Payment;